module.exports = __webpack_public_path__ + "static/media/Neil Pic Light.895c5eae.jpg";